import { render, staticRenderFns } from "./c_divider.vue?vue&type=template&id=531f2731&scoped=true"
import script from "./c_divider.vue?vue&type=script&lang=js"
export * from "./c_divider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "531f2731",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/chillzon/Documents/projects/crmeb_view/mer_plat_admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('531f2731')) {
      api.createRecord('531f2731', component.options)
    } else {
      api.reload('531f2731', component.options)
    }
    module.hot.accept("./c_divider.vue?vue&type=template&id=531f2731&scoped=true", function () {
      api.rerender('531f2731', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pagediy/components/mobileConfigRight/c_divider.vue"
export default component.exports